var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWalkingFilled = function SvgWalkingFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#currentColor",
    d: "M13.356 5.407c1.079 0 1.961-.88 1.961-1.954A1.963 1.963 0 0 0 13.356 1.5c-1.08 0-1.962.88-1.962 1.953 0 1.075.883 1.954 1.962 1.954m-3.63 3.32L6.982 22.5h2.06l1.765-7.814 2.06 1.954v5.86h1.96v-7.326l-2.059-1.953.589-2.93a7.2 7.2 0 0 0 5.394 2.442v-1.954c-1.863 0-3.433-.977-4.217-2.344l-.981-1.563a2.11 2.11 0 0 0-2.6-.82L6 8.142v4.59h1.962v-3.32z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWalkingFilled);
export default ForwardRef;